import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dayOfWeek'
})
export class DayOfWeekPipe implements PipeTransform {
  transform(index: number): string {
    const weekDays = {
      0: 'Segunda',
      1: 'Terça',
      2: 'Quarta',
      3: 'Quinta',
      4: 'Sexta',
      5: 'Sábado',
      6: 'Domingo'
    };
  
    // Handle today and tomorrow
    if (index === 0) return 'Hoje';
    if (index === 1) return 'Amanhã';
  
    // For other days, use moment to calculate the weekday and return the corresponding weekday name
    const weekday = moment().add(index, 'd').weekday();
    
    // If the index is invalid, return an empty string or a fallback string
    return weekDays[weekday] || 'Dia inválido';
  }
  
}
